var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskProgress3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1112,
    height: 938,
    viewBox: "0 0 1112 938",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1112,
    height: 938,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M499 535C499 532.791 500.798 530.974 502.99 531.25C508.507 531.943 513.774 534.066 518.253 537.44C523.801 541.619 527.839 547.49 529.757 554.167C531.674 560.843 531.367 567.963 528.882 574.449C526.396 580.936 521.868 586.437 515.98 590.123C510.092 593.809 503.165 595.479 496.244 594.881C489.324 594.283 482.786 591.449 477.618 586.807C472.45 582.166 468.932 575.968 467.597 569.152C466.519 563.649 466.91 557.984 468.697 552.718C469.407 550.626 471.826 549.802 473.813 550.767C475.801 551.733 476.593 554.122 475.971 556.242C474.893 559.917 474.704 563.817 475.448 567.614C476.449 572.726 479.087 577.374 482.963 580.856C486.839 584.337 491.743 586.462 496.933 586.911C502.124 587.36 507.319 586.107 511.735 583.343C516.151 580.578 519.547 576.452 521.411 571.587C523.275 566.722 523.506 561.383 522.068 556.375C520.629 551.368 517.601 546.964 513.44 543.83C510.349 541.502 506.759 539.968 502.982 539.333C500.803 538.966 499 537.209 499 535Z",
    fill: "#FF8B85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M493.349 569.348L505.349 557.348",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M493.349 559.348L493.349 569.348L503.349 569.348",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskProgress3);
export default __webpack_public_path__ + "static/media/task-progress-3.9ad0a994da913e91da191e9b67fabeba.svg";
export { ForwardRef as ReactComponent };